var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"banner_image":_vm.banner}}),_c('lightbox',{attrs:{"id":"art_gallery","images":_vm.art_pieces,"image_class":'art',"album_class":'art-album',"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }